import React from 'react'
import { Marquee } from '@devnomic/marquee'
import classNames from 'classnames'
import LazyHydrate from 'react-lazy-hydration'
import useWindowSize from '@/utils/useWindowSize'

interface ScrollingTitlesProps {
  className?: string
}

export const ScrollingTitles: React.FC<ScrollingTitlesProps> = (props) => {
  const { innerWidth, innerHeight } = useWindowSize()
  const imageHeight = React.useMemo(() => {
    return innerWidth > 2000
      ? '400px'
      : innerWidth > 1300
      ? '300px'
      : innerWidth > 768
      ? '220px'
      : innerHeight > 670
      ? '165px'
      : '140px'
  }, [innerWidth, innerHeight])
  const imageWidth = React.useMemo(() => {
    return innerWidth > 2000
      ? '267px'
      : innerWidth > 1300
      ? '200px'
      : innerWidth > 768
      ? '147px'
      : innerHeight > 670
      ? '110px'
      : '93px'
  }, [innerWidth, innerHeight])
  const imageZoom = React.useMemo(() => {
    return innerWidth > 2000 ? 1.33 : innerWidth > 1300 ? 0 : innerWidth > 768 ? 0.73 : innerHeight > 670 ? 0.55 : 0.46
  }, [innerWidth, innerHeight])
  const sprite = 'https://images.angelstudios.com/image/upload/v1732132444/angel-studios/guild/hero/css_sprites_5.webp'

  const CABRINI = { x: -10, y: -10 }
  const SOUND_OF_HOPE_THE_STORY_OF_POSSUM_TROT = { x: -230, y: -10 }
  const THE_LUNATIC_FARMER = { x: -450, y: -10 }
  const SOUND_OF_FREEDOM = { x: -670, y: -10 }
  const HOMESTEAD = { x: -890, y: -10 }
  const THE_MOSAIC_CHURCH = { x: -10, y: -330 }
  const BONHOEFFER = { x: -230, y: -330 }
  const SOMETHING_TO_STAND_FOR_WITH_MIKE_ROWE = { x: -450, y: -330 }
  const THE_SHIFT = { x: -670, y: -330 }
  const THE_KING_OF_KINGS = { x: -890, y: -330 }
  const TUTTLE_TWINS = { x: -10, y: -650 }
  const WINGFEATHER_SAGA = { x: -230, y: -650 }
  const THE_LAST_RIFLEMAN = { x: -450, y: -650 }
  const RIOT = { x: -670, y: -650 }
  const GABRIEL_AND_THE_GUARDIANS = { x: -890, y: -650 }

  const firstColumn = [
    CABRINI,
    SOUND_OF_HOPE_THE_STORY_OF_POSSUM_TROT,
    TUTTLE_TWINS,
    THE_LAST_RIFLEMAN,
    THE_MOSAIC_CHURCH,
  ]
  const secondColumn = [
    THE_SHIFT,
    THE_KING_OF_KINGS,
    HOMESTEAD,
    SOMETHING_TO_STAND_FOR_WITH_MIKE_ROWE,
    SOUND_OF_FREEDOM,
  ]
  const thirdColumn = [BONHOEFFER, WINGFEATHER_SAGA, THE_LUNATIC_FARMER, RIOT, GABRIEL_AND_THE_GUARDIANS]

  return (
    <div
      className={classNames(
        'z-10 mb-[45px] flex h-1/3 w-full justify-center gap-x-4 opacity-70 lg:my-0 lg:h-full lg:w-1/2 lg:justify-center lg:opacity-100',
        props.className,
      )}
    >
      <link
        rel="preload"
        href="https://images.angelstudios.com/image/upload/v1732132444/angel-studios/guild/hero/css_sprites_5.webp"
        as="image"
      ></link>
      <LazyHydrate whenVisible>
        <>
          {innerWidth && innerHeight && (
            <Marquee direction="up" reverse className="fade-marquee h-full w-1/3 animate-fadein md:w-auto">
              {firstColumn?.map((poster) => {
                const background = `url('${sprite}') ${poster.x}px ${poster.y}px`
                return (
                  <div
                    key={JSON.stringify({ poster })}
                    style={{
                      height: imageHeight,
                      width: imageWidth,
                    }}
                    className="rounded-2xl"
                  >
                    <div
                      style={{
                        background,
                        zoom: imageZoom,
                      }}
                      className="pointer-events-none h-full w-full max-w-full touch-none select-none rounded-2xl bg-center"
                    />
                  </div>
                )
              })}
            </Marquee>
          )}
        </>
      </LazyHydrate>
      <LazyHydrate whenVisible>
        <>
          {innerWidth && innerHeight && (
            <Marquee
              direction="up"
              className="fade-marquee h-full w-1/3 animate-fadein [--duration:32s] md:w-auto"
              innerClassName="[--duration:32s]"
            >
              {secondColumn?.map((poster) => {
                const background = `url('${sprite}') ${poster.x}px ${poster.y}px`
                return (
                  <div
                    key={JSON.stringify({ poster })}
                    style={{
                      height: imageHeight,
                      width: imageWidth,
                    }}
                    className="rounded-2xl"
                  >
                    <div
                      style={{
                        background,
                        zoom: imageZoom,
                      }}
                      className="pointer-events-none h-full w-full max-w-full touch-none select-none rounded-2xl bg-center "
                    />
                  </div>
                )
              })}
            </Marquee>
          )}
        </>
      </LazyHydrate>
      <LazyHydrate whenVisible>
        <>
          {innerWidth && innerHeight && (
            <Marquee direction="up" reverse className="fade-marquee w-1/3 animate-fadein md:w-auto">
              {thirdColumn?.map((poster) => {
                const background = `url('${sprite}') ${poster.x}px ${poster.y}px`
                return (
                  <div
                    key={JSON.stringify({ poster })}
                    style={{
                      height: imageHeight,
                      width: imageWidth,
                    }}
                    className="rounded-2xl"
                  >
                    <div
                      style={{
                        background,
                        zoom: imageZoom,
                      }}
                      className="pointer-events-none h-full w-full max-w-full touch-none select-none rounded-2xl bg-center"
                    />
                  </div>
                )
              })}
            </Marquee>
          )}
        </>
      </LazyHydrate>
    </div>
  )
}
